import { libTypes } from "@holta/lib";
import React from "react";
import { useStore } from "../../hooks/useStore";

export const SuppliersContext = React.createContext(undefined);

export const useSuppliersContext = () => {
    const context = React.useContext(SuppliersContext);
    if (context === undefined) {
        throw new Error("useSuppliersContext must be within the correct provider");
    }
    return context;
};

export const useContextValue = () => {
    
};
